import React, { Component, useState }  from 'react'
import { ButtonGroup,Button } from '@material-ui/core';
import {Link} from 'react-router-dom';
import MyButton from '../../../utils/MyButton';
import {FaArrowCircleLeft} from "react-icons/fa";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {getListaCalMes} from '../../../redux/actions/dataactions'; 


import   {  PDFViewer }   from '@react-pdf/renderer';
import './ProgramacionCalPDF.css';
import ProgramacionCalDocuPDF from './ProgramacionCalDocuPDF';

export class ProgramacionCalPDF extends Component {
    constructor(){
        super();
        this.state={
            equiposcal:{},
            errors:{},
            open:false,
            verWeb:false,
            verPDF:false
        };
        
    };
    
    componentDidMount(){
        this.props.getListaCalMes(this.props.match.params.clienteId,this.props.match.params.mes,this.props.match.params.year)
       
       
      
      }

      handleOpen = () => {
        if(this.state.verWeb){
            this.setState({ verWeb: false });
        }else{
            this.setState({ verWeb: true,verPDF:false});
        }
        
      };

      handleOpenPDF = () => {
        if(this.state.verPDF){
            this.setState({ verPDF: false });
        }else{
            this.setState({ verPDF: true,verWeb:false});
        }
        
      };

  render() {
    const {equiposcal,loading}= this.props.data;



    

    return (
      <div className='div-inventaripdfgeneral'>
      
      <div className='div-inventaripdftitulo'>


      <div className="div_boton">
                <Link to={`/dashboard/perfilcliente/${this.props.match.params.clienteId}`}>
                <MyButton tip="Volver">
                 <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente"/>
                </MyButton>
                </Link>
                </div> 

        <ButtonGroup variant="text" aria-label="text button group" color='primary'>

        <Button onClick={this.handleOpenPDF}>
        {this.state.verPDF? "Ocultar PDF":"Ver PDF"}</Button>
              


        </ButtonGroup>
        </div>

        <div className='div-inventariopdfcontent'>
        {equiposcal ? (
        <>
        
        {this.state.verPDF ?  <PDFViewer style={{ width: "100%", height: "90vh" }}>
            <ProgramacionCalDocuPDF equipos={equiposcal} />
          </PDFViewer>  : null}
        
        </>
        ) : null}
        </div>
       
      </div>
    )
  }
}

ProgramacionCalPDF.propTypes={
    getListaCalMes:PropTypes.func.isRequired,
    data:PropTypes.object.isRequired, 
}
const mapStateToProps=state=>({
    data:state.data
})
export default connect(mapStateToProps,{getListaCalMes}) (ProgramacionCalPDF);